import {useCallback} from 'react';
import {
  useLazyGetBiotwinConditionsQuery,
  useLazyGetBiotwinQuery,
  useLazyGetRelevantConditionsQuery,
} from '../../../app/services/biotwinApi';
import {downloadJSON} from '../../../app/utils/downloadUtils';
import {ConditionRelationType, ConditionTypeName} from '../types';

export const useExportBiotwin = () => {
  const [getBiotwin] = useLazyGetBiotwinQuery();
  const [getBiotwinConditions] = useLazyGetBiotwinConditionsQuery();
  const [getRelevantConditions] = useLazyGetRelevantConditionsQuery();

  const exportBiotwin = useCallback(async (biotwinId: number) => {
    const biotwin = await getBiotwin({id: biotwinId}).unwrap();
    const biotwinConditions = await getBiotwinConditions({userId: biotwinId}).unwrap();
    const relevantConditions = await getRelevantConditions({userId: biotwinId}).unwrap();

    const data = {
      biotwin: {
        name: biotwin.name,
        dateOfBirth: biotwin.dateOfBirth,
        gender: biotwin.gender,
        height: biotwin.height,
        heightUnit: biotwin.heightUnit,
        note: biotwin.note,
        weight: biotwin.weight,
        weightUnit: biotwin.weightUnit,
      },
      biotwinConditions: biotwinConditions.map((condition) => ({
        conditionId: condition.conditionId,
        date: condition.date,
        note: condition.note,
        unitId: condition.unitId,
        value: condition.value,
      })),
      demographicConditionIds: relevantConditions
        .filter((condition) => condition.conditionTypeName === ConditionTypeName.Demographic)
        .map((condition) => condition.conditionId),
      selectedConditionIds: relevantConditions
        .filter((condition) => condition.conditionRelationType === ConditionRelationType.Selected)
        .map((condition) => condition.conditionId),
      requiredRelatedConditionIds: relevantConditions
        .filter((condition) => condition.conditionRelationType === ConditionRelationType.RequiredRelated)
        .map((condition) => condition.conditionId),
    };
    const filename = `biotwin-${biotwin.name ?? 'export'}-${Date.now()}.json`;

    downloadJSON(data, filename);
  }, []);

  return {exportBiotwin};
};
